import * as React from "react";
import {SyntheticEvent} from "react";
import {observer} from "mobx-react";

import "./topic-switcher.scss";

import {Button, Menu, Popup as SemanticPopup} from "semantic-ui-react";

import {TopicConfiguration} from "../../../config/topic-configuration";
import MediaQuery from "react-responsive";
import {Icon} from "../icon/icon";
import {IAppStore, withStore} from "../../stores/abstract-app-store";

export interface TopicSwitcherButtonProps {
    topics: TopicConfiguration[];
    showTopic?: boolean;
    store?: IAppStore; // this is injected by withStore
}

@observer
class TopicSwitcherButtonBase extends React.Component<TopicSwitcherButtonProps, any> {
    widgetKey = "topic-switcher-button";
    constructor(props: TopicSwitcherButtonProps) {
        super(props);
        this.handleToggle = this.handleToggle.bind(this);
    }

    handleToggle(event?: SyntheticEvent) {
        const {store} = this.props;
        if (store?.TopicSwitcherStore.visible) {
            store?.TopicSwitcherStore.setVisible(false);
        } else {
            store?.TopicSwitcherStore.setVisible(true);
            if(store?.uiStore.isSmallDevice) {
                store?.uiStore.setSidebarVisible(true);
            }
        }
        if(event) {
            event.preventDefault();
        }
    }

    componentDidMount(): void {
        const {store} = this.props;
        if (store?.uiStore.widgets.has(this.widgetKey)) {
            return;
        }
        store?.uiStore.addWidget(this.widgetKey, this);
    }

    componentWillUnmount(): void {
        const {store} = this.props;
        store?.uiStore.removeWidget(this.widgetKey);
    }

    render() {
        const {showTopic, store} = this.props;
        if (!store) {
            return null;
        }
        const {subtopic} = store.appStore;
        if (!subtopic) {
            return null;
        }

        if (showTopic) {
            if(store.mapViewerConfig.subtopics?.length>1) {
                return <SemanticPopup
                    content={store.mapViewerConfig.topicSwitcher?.button}
                    disabled={store.TopicSwitcherStore.visible}
                    trigger={<Menu.Item
                        as={Button}
                        onClick={this.handleToggle} className="geo-topic-switcher">
                        <MediaQuery minWidth={store.mapViewerConfig.breakpoints.md}>
                            <Icon name={"navigate_down"} className={"icon--topic-switcher"} />
                        </MediaQuery>
                        {subtopic?.icon ? <Icon name={subtopic.icon}/> : null}
                        <span
                            className="geo-topic-switcher-label">
                            {subtopic?.label ? subtopic.label : subtopic?.name}</span>
                    </Menu.Item>}
                    on={"hover"}/>;
            } else {
                return <h1><span>{subtopic?.label ? subtopic.label : subtopic?.name}</span></h1>;
            }
        } else {
            return <div className={"geo-topic-switcher"}><Button
                compact
                size={"mini"}
                onClick={this.handleToggle}>
                <Icon name={"signpost"} className={"icon--topic-switcher"} />
                {store.mapViewerConfig.topicSwitcher?.button}
            </Button></div>;
        }
    }
}

export const TopicSwitcherButton = withStore(TopicSwitcherButtonBase);
